module.exports = __webpack_public_path__ + "img/sand.dad343cf.png";